import React, { useState } from "react";
import GenericButton from "../../common/genericButton";
import GenericInput from "../../common/GenericInput";
import GenericModal from "../../common/genericModal";
import CheckBox from "../../common/CheckBox/checkBox";
import styles from "./SignUp.module.scss";
import { Link, useHistory } from "react-router-dom";
import Login from "../login";

const SignUp = ({ isOpen, toggle, handleLogIn }) => {
  const history = useHistory();
  const handleLogin = () => {
    history.push("/wallet");
  };
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
        <div className={styles.mainheading}>Sign Up</div>
        <div className={styles.title}>Enter Your Email and New Password</div>

        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Name"
            placeholder="Enter Your Name"
            type="text"
            withRightIcon={false}
            name="name"
            icon={"/assets/user.svg"}
            onChange={changeHandler}
          />
        </div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Email"
            placeholder="Enter your email "
            type="text"
            withRightIcon={false}
            name="email"
            icon={"/assets/icons-email.svg"}
            onChange={changeHandler}
          />
        </div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Password"
            placeholder="..... "
            type="text"
            withRightIcon={"/assets/lock.png"}
            name="Passowrd"
            icon={"/assets/key.svg"}
            onChange={changeHandler}
            className={styles.generic}
          />
        </div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label="Repeat Password"
            placeholder="....."
            type="text"
            withRightIcon={"/assets/lock.png"}
            name="resetPassowrd"
            icon={"/assets/key.svg"}
            onChange={changeHandler}
            lefticon={"/assets/lock.png"}
            className={styles.generic}
          />
        </div>
        <div className={styles.fieldWrapper}>
          <CheckBox />
        </div>
        <div className={styles.buttonWrapper}>
          <GenericButton title={"Sign Up"} onClick={() => handleLogin()} />
        </div>
        

        <div className={styles.footerdiv}>
          <p>or</p>
          <p>
            Already have account?{" "}
            <span onClick={handleLogIn} style={{ cursor: "pointer" , color:"#5033a1!important"}}>
              Login
            </span>{" "}
          </p>
        </div>
      </GenericModal>
    </>
  );
};

export default SignUp;
